export const environment = {
  production: false,
  googleAnalyticsId: 'GGTM-TNKVTPQCSTAGE',
  client_secret: '3qBmo6nzUCzuUlukbb0WzWqDsJhA42ZaMDPR6g41xMlmasHnJpZthaOBpo3wXoYSfpEAC5orjCJuUuHjDjYqVnSTyK7J2UAtcLJu76xcmiKFkpTwVldCTTfUhuMyClr3',
  client_id: 'ovCBtZZ7YK0VcsikeOI1eYFhn5KdYxvKOxHDyB9U',
  url: 'https://dev.services.solfium.com/',
  url_desk: 'https://dev.services.solfium.com/solfdesk/',
  url_sell: 'https://dev.services.solfium.com/solfsell/',
  url_notify: 'https://dev.services.solfium.com/',
  url_framer: 'https://pre.solfium.com/',
  url_clients:  'https://dev.services.solfium.com/clients/?quotation=1',
  api_sell: 'solfapi/sell/api/',
  api_auth: 'solfapi/auth/',
  api_cli: 'solfapi/cli/api/',
  api_chat: 'solfapi/chat/api/',
  api_desk: 'solfapi/desk/api/',
  api_inst: 'solfapi/inst/api/',
  api_form: 'solfapi/form/api/',
  email : 'info@solfium.com',
  address_mex : 'The Village Juriquilla: Av. de las Ciencias 3015,',
  address_mex_2 : 'Oficinas 601 y 612, Santa Fé, 76230 Juriquilla, Qro.',
  address_ca : '1250 René-Lévesque Blvd W, Suite 2200',
  address_ca_2 : 'Montréal, QC, Canada H3B 4W8',
  instagram : 'https://www.instagram.com/solfium/',
  linkedin : 'https://www.linkedin.com/company/solfium/',
  facebook : 'https://www.facebook.com/Solfium',
  app_store : 'https://apps.apple.com/ca/app/solfium/id1594366647',
  play_store : 'https://play.google.com/store/apps/details?id=com.solfium',
  app_galery: 'https://appgallery.huawei.com/search/solfium?1648573259293',
  language_default: 'mx',
  //array_lenguage : ['mx','en','fr','bra'],
  array_lenguage : ['mx','en'],
  array_lenguage_name : {'mx': 'Español', 'en': 'English'},
  array_partnerships: ['amda', 'balvanera','cancham', 'cibanco', 'crea', 'dlocal', 'eckerle', 'ecominig', 'ecotech', 'global_compact',
                      'gobierno_queretaro','gobierno_puebla','greentech-alliance', 'ITC', 'jobimpulse', 'prettl_group', 'sharechange', 'tar_aerolineas'],
  basic_auth: "dXNlcjpwYXNz",
  promoter_scotiabank: "SCOTIABANK",
  promoter_santander: "SANTANDER",
  promoter_buenfin: "BUENFIN",
  promoter_asturiano: "ASTURIANO",
  promoter_clubcampestre: "CLUBCAMPESTRE",
  promoter_cajalibertad: "CAJALIBERTAD",
  promoter_marykay: "MARYKAY",
  promoter_dhl: "DHL",
  promoter_mvs: "MVS",
  promoter_bh: "BH",
  promoter_heb: "HEB",
  promoter_ricacocacola: "RICA",
  promoter_refiere: "client",
  popup_timer: 60000,
  redirect_timer: 60000,
  panel_watts: 0.575
};
